import React, { Component } from 'react'
import { connect } from 'react-redux'

import { authFromToken } from '../actions/authActions'

import LoginPanel from './LoginPanel'
import AdminLayout from './AdminLayout'
import ErrorContainer from '../Shared/ErrorContainer'
import Loader from '../Shared/Loader'

class Admin extends Component {

    componentDidMount() {
        this.props.authFromToken()
    }

    render() {
        const { user, loading, authenticating, error } = this.props

        if (error) return <ErrorContainer error={error} />

        if (authenticating) return <Loader />

        if (!user || user !== 'admin') return <LoginPanel title="Ylläpito" />

        return <AdminLayout loading={loading} />
    }
}

const mapStoP = state => {
    const loading = (
        state.clients.loading ||
        state.locationsData.loading ||
        state.measurements.loading ||
        state.measurements.loadingInfo
    )
    var error = ''
    if (state.clients.error) error = 'Asiakastietoja ei voitu ladata'
    if (state.locationsData.error) error = 'Kohdetietoja ei voitu ladata'
    if (state.measurements.error) error = 'Mittaustietoja ei voitu ladata'
    if (state.measurements.errorInfo) error = 'Rakennuksen tietoja ei voitu ladata'

    return {
        authenticating: state.auth.loading,
        loading: loading,
        error: error,
        user: state.auth.user
    }
}

const mapDtoP = dispatch => {
    return {
        authFromToken: () => dispatch(authFromToken())
    }
}

export default connect(mapStoP, mapDtoP)(Admin)
export { Admin }


// WEBPACK FOOTER //
// ./src/Admin/Admin.js